export default __webpack_public_path__ + "static/media/jaipur.3f7eb937.jpg";